import styled from 'styled-components'

const DataOriginText = styled.span`
  max-width: 95px;
`

export default DataOriginText



// WEBPACK FOOTER //
// ./src/app/components/normal/DataOriginText.js